import React, { Component } from "react";
import { Link } from "react-router-dom";
// import "simple-line-icons/css/simple-line-icons.css";
// import "font-awesome/css/font-awesome.min.css";
// import "ti-icons/css/themify-icons.css";
// import "perfect-scrollbar/dist/perfect-scrollbar.min.js";
import Constant from "../../../Constant.js";
// import Checkbox from "rc-checkbox";
// import "rc-checkbox/assets/index.css";
import Checkbox from "react-simple-checkbox";
import ImageUploader from "react-images-upload";

export default class EditQuestion extends Component {
  state = {
    gameTypeList: [
      {
        game_type_id: 1,
        game_type_name: "Sentence Type",
        game_type_description: "Sentence Type",
        main_game_type_id: 1,
      },
      {
        game_type_id: 2,
        game_type_name: "Four Pic One Word",
        game_type_description: "Four Pic One Word",
        main_game_type_id: 2,
      },
      {
        game_type_id: 3,
        game_type_name: "Sequence",
        game_type_description: "Sequence",
        main_game_type_id: 3,
      },
      {
        game_type_id: 4,
        game_type_name: "Bubble",
        game_type_description: "Bubble",
        main_game_type_id: 4,
      },
      // {
      //   "game_type_id": 5,
      //   "game_type_name": "Image Base",
      //   "game_type_description": "Image Base",
      //   "main_game_type_id": 5
      // },
      // {
      //   "game_type_id": 8,
      //   "game_type_name": "Audio Recognition",
      //   "game_type_description": "Audio Recognition",
      //   "main_game_type_id": 8
      // },
      // {
      //   "game_type_id": 9,
      //   "game_type_name": "Make sentence",
      //   "game_type_description": "Make sentence",
      //   "main_game_type_id": 9
      // },
      // {
      //   "game_type_id": 10,
      //   "game_type_name": "Stepbasedgame",
      //   "game_type_description": "Stepbasedgame",
      //   "main_game_type_id": 1
      // }
    ],
    questionTypeList: [],
    answerTypeList: [],
    question: {
      question_title: "",
      question_options: [],
    },
    question_options: [],
    pictures: [],
  };
  componentDidMount() {
    this.getQuestionDetails();
  }
  getQuestionDetails = () => {
    var question_id = this.props.question.question_id;
    var game_type_id = this.props.question.game_type_id;
    var question_type_id = this.props.question.question_type_id;
    var question_title = this.props.question.question_title;
    var correct_feedback = this.props.question.correct_feedback;
    var incorrect_feedback = this.props.question.incorrect_feedback;
    var answer_type_id = this.props.question.answer_type_id;
    var question_media = this.props.question.question_media;
    if (this.props.question.question_options !== null) {
      var question_options = this.props.question.question_options;
    } else {
      var question_options = [];
    }
    console.log(this.state.question_options);

    this.setState({
      question_id,
      game_type_id,
      question_type_id,
      question_title,
      correct_feedback,
      incorrect_feedback,
      answer_type_id,
      question_options,
      question_media,
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.question.question_id !== this.props.question.question_id) {
      console.log(this.props.question);
      this.setState({ question: this.props.question });
      var question_id = this.props.question.question_id;
      var game_type_id = this.props.question.game_type_id;
      var question_type_id = this.props.question.question_type_id;
      var question_title = this.props.question.question_title;
      var correct_feedback = this.props.question.correct_feedback;
      var incorrect_feedback = this.props.question.incorrect_feedback;
      var answer_type_id = this.props.question.answer_type_id;
      var question_options = this.props.question.question_options;
      var question_media = this.props.question.question_media;

      if (this.props.question.question_title != undefined) {
        this.setState({
          question_id,
          game_type_id,
          question_type_id,
          question_title,
          correct_feedback,
          incorrect_feedback,
          answer_type_id,
          question_options,
          question_media,
        });
      } else {
        this.setState({
          question_id: "",
          game_type_id: "",
          question_type_id: "",
          question_title: "",
          correct_feedback: "",
          incorrect_feedback: "",
          answer_type_id: "",
          question_options: [],
          question_media: [],
        });
      }
    }
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name == "option") {
      var question_options = this.state.question_options;
      for (let i = 0; i < question_options.length; i++) {
        if (i == e.target.id) {
          question_options[i].option_name = e.target.value;
        }
      }
      this.setState({ question_options: question_options });
    }

    // console.log(question);
    setTimeout(() => {
      this.onEditQuestion();
    }, 20);
  };

  onEditQuestion = () => {
    var question = {};
    question.question_id = this.state.question_id;
    question.game_type_id = this.state.game_type_id;
    question.question_type_id = this.state.question_type_id;
    question.question_title = this.state.question_title;
    question.correct_feedback = this.state.correct_feedback;
    question.incorrect_feedback = this.state.incorrect_feedback;
    question.answer_type_id = this.state.answer_type_id;
    question.question_options = this.state.question_options;
    question.question_media = this.state.question_media;
    this.props.onEditQuestion(question);
  };

  onSave = () => {
    var question = {};
    question.question_id = this.state.question_id;
    question.game_type_id = this.state.game_type_id;
    question.question_type_id = this.state.question_type_id;
    question.question_title = this.state.question_title;
    question.correct_feedback = this.state.correct_feedback;
    question.incorrect_feedback = this.state.incorrect_feedback;
    question.answer_type_id = this.state.answer_type_id;
    question.question_options = this.state.question_options;
    question.question_media = this.state.question_media;
    this.props.onSave(question);
  };
  addNewOption = () => {
    var question_options = this.state.question_options;
    var obj = {
      option_name: "",
      right_answer: "0",
    };
    question_options.push(obj);

    this.setState({ question_options: question_options });
    this.onEditQuestion();
  };
  deleteOption = (id) => {
    var question_options = this.state.question_options;
    for (let i = 0; i < question_options.length; i++) {
      if (i == id) {
        question_options.splice(i, 1);
      }
    }
    this.setState({ question_options: question_options });
    this.onEditQuestion();
  };
  onCheck = (id, e) => {
    var question_options = this.state.question_options;
    for (let i = 0; i < question_options.length; i++) {
      if (i == id) {
        if (question_options[i].right_answer == 0) {
          question_options[i].right_answer = 1;
        } else {
          question_options[i].right_answer = 0;
        }
      } else {
        question_options[i].right_answer = 0;
      }
    }
    this.setState({ question_options: question_options });
    this.onEditQuestion();
  };
  onDrop = (picture) => {
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
  };
  render() {
    return (
      <div>
        <div className="row">
          <div class="col-md-12 mt-3">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Select Game Type</label>
              <select
                class="form-control"
                id="exampleFormControlSelect2"
                onChange={this.onInputChange}
                name="game_type_id"
              >
                {this.state.gameTypeList.map((gameType) =>
                  gameType.game_type_id == this.state.game_type_id ? (
                    <option selected value={gameType.game_type_id}>
                      {gameType.game_type_name}
                    </option>
                  ) : (
                    <option value={gameType.game_type_id}>
                      {gameType.game_type_name}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>
          {/* <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">Question Type</label>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect2"
                    onChange={this.onInputChange}
                    name="question_type_id"
                  >
                    {this.state.questionTypeList.map(questionType =>
                      questionType.question_type_id ==
                      this.state.question_type_id ? (
                        <option selected value={questionType.question_type_id}>
                          {questionType.type_name}
                        </option>
                      ) : (
                        <option value={questionType.question_type_id}>
                          {questionType.type_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div> */}
          {this.state.game_type_id == 5 ? (
            <div class="col-md-12">
              <ImageUploader
                withIcon={true}
                buttonText="Choose images"
                onChange={this.onDrop}
                imgExtension={[".jpg", ".gif", ".png", ".gif"]}
                maxFileSize={5242880}
                withPreview={true}
              />
            </div>
          ) : (
            ""
          )}

          <div class="col-md-12">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Question Title</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Question Title"
                aria-label="Username"
                value={this.state.question_title}
                name="question_title"
                onChange={this.onInputChange}
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Correct Feedback</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Correct Feedback"
                aria-label="Username"
                value={this.state.correct_feedback}
                name="correct_feedback"
                onChange={this.onInputChange}
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Incorrect Feedback</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Incorrect Feedback"
                aria-label="Username"
                value={this.state.incorrect_feedback}
                name="incorrect_feedback"
                onChange={this.onInputChange}
              />
            </div>
          </div>
          {/* <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect2">Answer Type</label>
                  <select
                    class="form-control"
                    id="exampleFormControlSelect2"
                    onChange={this.onInputChange}
                    name="question_answer_type_id"
                  >
                    {this.state.answerTypeList.map(answerType =>
                      answerType.question_answer_type_id ==
                      this.state.answer_type_id ? (
                        <option
                          selected
                          value={answerType.question_answer_type_id}
                        >
                          {answerType.type_name}
                        </option>
                      ) : (
                        <option value={answerType.question_answer_type_id}>
                          {answerType.type_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div> */}

          <div class="col-lg-12">
            <label for="exampleFormControlSelect2">Options</label>
            <form class="form-inline repeater">
              {this.state.question_options !== null
                ? this.state.question_options.map((option, key) => (
                    <div class="form-group">
                      <div class="form-group">
                        <div class="input-group ml-0 mb-3 d-flex align-items-center">
                          <div class="input-group-prepend">
                            <span class="input-group-text border-none rounded shadow-sm">
                              <Checkbox
                                color={"#4CAF50"}
                                size={2}
                                className="top-0"
                                borderThickness={2}
                                checked={
                                  option.right_answer == 0 ? false : true
                                }
                                onChange={this.onCheck.bind(this, key)}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            class="form-control shadow-sm mx-1"
                            id={key}
                            placeholder="Option"
                            name={`option`}
                            value={option.option_name}
                            onChange={this.onInputChange}
                          />
                          <div class="input-group-append">
                            <span  onClick={this.deleteOption.bind(this, key)} class="input-group-text  border-none rounded shadow-sm bg-danger">
                              <i className="fa fa-trash py-1 text-white"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    // <div data-repeater-list="group-a">
                    //   <div data-repeater-item class="d-flex mb-2">
                    //     <label class="sr-only" for="inlineFormInputGroup2">
                    //       Add User
                    //     </label>
                    //     <div class="input-group ml-0 mb-2 mb-sm-0">
                    //       <div class="input-group-prepend">
                    //         <span class="input-group-text px-2">
                    //           <Checkbox
                    //             color={"#4CAF50"}
                    //             size={3}
                    //             className="top-0"
                    //             borderThickness={2}
                    //             checked={
                    //               option.right_answer == 0 ? false : true
                    //             }
                    //             onChange={this.onCheck.bind(this, key)}
                    //           />
                    //         </span>
                    //       </div>
                    //       <input
                    //         type="text"
                    //         class="form-control"
                    //         id={key}
                    //         placeholder="Option"
                    //         name={`option`}
                    //         value={option.option_name}
                    //         onChange={this.onInputChange}
                    //       />
                    //     </div>
                    //     <button
                    //       data-repeater-delete
                    //       type="button"
                    //       class="btn btn-danger btn-sm icon-btn ml-2"
                    //       onClick={this.deleteOption.bind(this, key)}
                    //     >
                    //       <i
                    //         class="fa fa-trash"
                    //         style={{ fontWeight: "bold" }}
                    //       ></i>
                    //     </button>
                    //   </div>
                    // </div>
                  ))
                : ""}
              <button
                data-repeater-create
                type="button"
                class="btn btn-success btn-sm icon-btn ml-2 mb-2 border-none rounded shadow-sm"
                onClick={this.addNewOption}
              >
                <i class="fa fa-plus"></i>
              </button>
            </form>
          </div>

        </div>
      </div>
    );
  }
}
